// Whether the ITEMS PAGE lists an item. A boat since sold, a home no longer
// owned: something whose history is worth keeping but that no longer belongs
// in the list you scan every day.
//
// This is the ONE module allowed to interpret `TaskPogoItem.visibility`.
//
// FAIL OPEN: null, absent and every unrecognized value all mean shown. Only
// the explicit 'hidden' marker hides. gen2-dev and gen2-prod are independent
// APIs and prod lags, so a value written by a newer dev build must degrade to
// showing the item, not to making it vanish -- the ItemTracking.mjs rule
// pointed at a list instead of a page.
//
// Hidden is presentation, never authorization, and it is honoured by exactly
// one surface: /me/item. The item's own page stays reachable by URL, and the
// Trips page, its item pickers, place visits and the status digests keep
// every item -- a hidden boat's trips are still its trips.

export const VISIBILITY_HIDDEN = 'hidden';

// True only for the explicit hidden marker; see the fail-open rule above.
export function isHiddenItem(item) {
  return item?.visibility === VISIBILITY_HIDDEN;
}

// What a write sends for "hidden" / "shown". Shown is null rather than a
// second marker: it clears the attribute, which is what every existing row
// already has, so unhiding leaves no trace to migrate.
export function visibilityValue(hidden) {
  return hidden ? VISIBILITY_HIDDEN : null;
}
